import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../lib/api";

const LINKS = [
  { id: "story", label: "Story", testid: "nav-link-story" },
  { id: "wines", label: "Wines", testid: "nav-link-wines" },
  { id: "club", label: "Club", testid: "nav-link-club" },
  { id: "events", label: "Events", testid: "nav-link-events" },
  { id: "visit", label: "Visit", testid: "nav-link-visit" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "glass-nav border-b border-[rgba(212,175,55,0.15)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[70px] flex items-center justify-between">
        <button data-testid="nav-brand-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-baseline gap-2 group">
          <span className="font-serif-display text-xl tracking-wide text-[#F4F1EA] group-hover:text-[#D4AF37] transition-colors duration-300">
            Delta Breeze
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#A39E93]">Winery</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-[#A39E93] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-join-club"
            onClick={() => go("club")}
            className="font-mono text-xs uppercase tracking-[0.2em] border border-[#D4AF37] text-[#D4AF37] px-5 py-2.5 hover:bg-[#D4AF37] hover:text-[#0A0908] transition-colors duration-300"
          >
            Join Club
          </button>
        </nav>

        <button data-testid="nav-mobile-menu-btn" className="md:hidden text-[#F4F1EA]" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden glass-nav border-t border-[rgba(212,175,55,0.15)] overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left font-mono text-sm uppercase tracking-[0.2em] text-[#F4F1EA]"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-cta-join"
                onClick={() => go("club")}
                className="font-mono text-sm uppercase tracking-[0.2em] text-[#D4AF37]"
              >
                Join the Club
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
